<template>
    <div class="text-xs-center" v-if="dialog">
        <v-dialog v-model="dialog" @keydown.enter="passChangeConfirm" @keydown.esc="passChangeCancel" persistent max-width="500" scrollable>
            <v-card>
            <v-card-title
                class="headline grey lighten-2"
                primary-title
            >
            {{this.title}}
            </v-card-title>
            <v-text-field :disable="loading" :loading="loading" prepend-icon="lock" name="password" label="Senha" id="password"
                type="password" v-model="password"/>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="mx-0" flat color="primary" @click.native="passChangeConfirm">{{'Confirmar'}}</v-btn>
                <v-btn class="mx-0" v-if="clearPassword" flat @click.native="() => {password = ''}">{{'remover Senha'}}</v-btn>
                <v-btn class="mx-0" flat @click.native="passChangeCancel">{{'Cancelar'}}</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        </div>
</template>

<script>
  export default {
    name: 'confirm',
    props: {
      clearPassword: {
        type: Boolean,
        default: false
      },
      dialog: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'Senha de Compartilhamento de Arquivo'
      }
    },
    data: () => ({
      password: ''
    }),
    methods: {
      passChangeConfirm () {
        this.$emit('passChangeConfirm', this.password)
        this.password = ''
      },
      passChangeCancel () {
        this.$emit('passChangeCancel')
        this.password = ''
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/shared/PFilePasswordDialog.vue